"use strict";
import "src/decidim/decidim_awesome/awesome_application.js";
import { definitionsFromContext } from "src/decidim/refactor/support/stimulus";
if (window.Stimulus) {
  const context = require.context("../src/decidim/controllers", true, /controller\.js$/);
  window.Stimulus.load(definitionsFromContext(context));
}
require.context("../images", true);
import "entrypoints/decidim_decidim_awesome.scss";
